var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : 'button',_vm._g({tag:"button",staticClass:"b2b-button",class:{
    'b2b-button--block': _vm.block,
    'b2b-button--dense': _vm.dense,
    'b2b-button--loading': _vm.loading,
    'b2b-button--flat': _vm.flat,
  },attrs:{"to":_vm.to,"type":!_vm.to && _vm.type,"disabled":_vm.$_disabled}},_vm.$_listeners),[(_vm.loading)?_c('b2b-loading'):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }